import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePermissions } from '../contexts/PermissionContext';
import { useFhirRealtime } from '../hooks/useFhirRealtime';
import {
  getNotificationTargetReference,
  resolveNotificationRoute,
} from '../lib/notificationFhir';
import { showInAppNotificationToast } from '../lib/showInAppNotificationToast';

/** Shows a toast when the shared notification WebSocket delivers a new unread item. */
export function InAppNotificationToastListener(): null {
  const navigate = useNavigate();
  const { isClient } = usePermissions();
  const { onNotificationReceived } = useFhirRealtime();

  useEffect(() => {
    return onNotificationReceived((comm) => {
      const targetRef = getNotificationTargetReference(comm);
      const route = resolveNotificationRoute(targetRef, { clientPortal: isClient });
      showInAppNotificationToast(comm, {
        onClick: route ? () => navigate(route) : undefined,
      });
    });
  }, [onNotificationReceived, navigate, isClient]);

  return null;
}
